// Sorted by resource prefix, then by lifecycle (created → completed →
// failed / updated) within each prefix — not strictly alphabetical.
// Keep this order so the UI selector and docs catalog render the
// natural lifecycle of each resource.
export const WEBHOOK_EVENT_TYPES = [
  "classification_run.created",
  "classification_run.completed",
  "classification_run.failed",
  "eval_experiment.completed",
  "eval_experiment.failed",
] as const;

export type WebhookEventType = (typeof WEBHOOK_EVENT_TYPES)[number];

export const WEBHOOK_TEST_EVENT_TYPE = "webhook.test" as const;
